import { render, staticRenderFns } from "./CreateProjectForm.vue?vue&type=template&id=b6e44e96"
import script from "./CreateProjectForm.vue?vue&type=script&lang=js"
export * from "./CreateProjectForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports